import React from "react";
import PropTypes from "prop-types";
import styles from "./Panel.module.scss";

function Panel({ children, className = "", wrapperClassName = "", ...rest }) {
    return (
        <div className={`${styles.panel} ${wrapperClassName}`} {...rest}>
            <div className={`${styles.panelInner} ${className}`}>
                {children}
            </div>
        </div>
    );
}

Panel.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    wrapperClassName: PropTypes.string,
};

export default React.memo(Panel);
